import React from 'react';
import { useSelector } from 'react-redux';

import { useReadAloud } from '../conquest/hooks/use-read-aloud';
import { getStrandsFromTags } from '../../helpers/utils';
import Activity from '../activity/activity';
import Header from '../header/header';
import { FooterQtc } from '../footer-qtc/footer-qtc';
import Spinner from '../../components/spinner/spinner';
import { MODULE_NAME_ACTIVITY } from '../../helpers/constants';
import css from './mle.scss';

const MleContainer = () => {
  const { initMleReducer, spinnerReducer } = useSelector(state => state);
  const activityMetaData = (initMleReducer.find(item => item.meta.name === MODULE_NAME_ACTIVITY) || {}).meta;
  const { tags, title, user: { locale } = {} } = activityMetaData || {};
  const { strand, subStrand } = getStrandsFromTags(tags, locale);
  const { readAloudConfig, onLocaleChange } = useReadAloud();

  return (
    <div className={css.mle}>
      <Header
        onLocaleChange={onLocaleChange}
        category={strand ? `${strand}${subStrand ? `: ${subStrand}` : ''}` : strand}
        title={title}
      />
      <div className={css.content}>
        <Activity
          readAloudConfig={readAloudConfig}
        />
      </div>
      <FooterQtc />
      <Spinner show={spinnerReducer.length > 0} />
    </div>
  );
};

export default MleContainer;
